// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body{background-color:#f5f5f5}.el-header{color:#333;background-color:#fff;line-height:60px}.el-button .material-design-icon{height:auto}.w-status i.w--enabled{color:#00b75c}.w-status i.w--disabled{color:#d8d8d8}.w-status i.w--broken{color:#d6000e}", ""]);
// Exports
module.exports = exports;
